/* Torvanto veiligheid: 1-klik toevoegen van PBM-producten (PDP-blok + cart-upsell).
   Zelfde patroon als torvanto-boor-wijzer.js: /cart/add.js + shopify:cart:lines-update. */
(function () {
  if (window.__tvVeiligheidInit) return;
  window.__tvVeiligheidInit = true;

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-tv-veiligheid-add]');
    if (!add || add.disabled || add.dataset.busy) return;
    add.dataset.busy = '1';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(add.dataset.tvVeiligheidAdd), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetch('/cart.js');
    }).then(function (r) { return r.json(); }).then(function (cart) {
      var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
      ev.promise = Promise.resolve({ cart: { totalQuantity: cart.item_count }, detail: { itemCount: cart.item_count } });
      document.dispatchEvent(ev);
      var t = add.textContent;
      add.textContent = '✓';
      add.classList.add('tv-veiligheid-added');
      setTimeout(function () { add.textContent = t; add.classList.remove('tv-veiligheid-added'); }, 2200);
    }).catch(function () { window.location.href = '/cart'; })
      .finally(function () { delete add.dataset.busy; });
  });
})();
